import { render, staticRenderFns } from "./UpdateJourneyLog.vue?vue&type=template&id=1380445c&"
import script from "./UpdateJourneyLog.vue?vue&type=script&lang=js&"
export * from "./UpdateJourneyLog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateJourneyLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports